import React, { useState } from "react";
import styled from "styled-components";
import StripeCheckout from "./StripeCheckout";

const Container = styled.div`
  max-width: 600px;
  margin: 40px auto;
  padding: 20px;
`;

const Title = styled.h1`
  color: #1a1a1a;
  margin-bottom: 24px;
`;

const TestAmounts = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  flex-wrap: wrap;
`;

const AmountButton = styled.button`
  padding: 8px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: ${(props) => (props.selected ? "#5469d4" : "white")};
  color: ${(props) => (props.selected ? "white" : "#1a1a1a")};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => (props.selected ? "#4050b5" : "#f5f5f5")};
  }
`;

const CustomAmount = styled.div`
  margin-bottom: 24px;
`;

const Input = styled.input`
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-right: 8px;
  width: 120px;
`;

const Status = styled.div`
  margin-top: 24px;
  padding: 16px;
  border-radius: 4px;
  background: #f5f5f5;
  font-family: monospace;
  white-space: pre-wrap;
`;

const StripeTest = () => {
  const [amount, setAmount] = useState(10.0);
  const [customAmount, setCustomAmount] = useState("");
  const [status, setStatus] = useState("");

  const testAmounts = [5.0, 10.0, 20.0, 50.0, 100.0];

  const handleCustomAmount = (e) => {
    e.preventDefault();
    const value = parseFloat(customAmount);
    if (!isNaN(value) && value > 0) {
      setAmount(value);
      setCustomAmount("");
    }
  };

  const handleSuccess = (paymentIntent) => {
    setStatus(
      JSON.stringify(
        {
          status: "success",
          paymentIntent,
          timestamp: new Date().toISOString(),
        },
        null,
        2
      )
    );
  };

  const handleError = (error) => {
    setStatus(
      JSON.stringify(
        {
          status: "error",
          error: {
            message: error.message,
            code: error.code,
            type: error.type,
          },
          timestamp: new Date().toISOString(),
        },
        null,
        2
      )
    );
  };

  return (
    <Container>
      <Title>Stripe Payment Test</Title>

      <TestAmounts>
        {testAmounts.map((testAmount) => (
          <AmountButton
            key={testAmount}
            selected={amount === testAmount}
            onClick={() => setAmount(testAmount)}
          >
            ${testAmount.toFixed(2)}
          </AmountButton>
        ))}
      </TestAmounts>

      <CustomAmount>
        <form onSubmit={handleCustomAmount}>
          <Input
            type="number"
            step="0.01"
            min="0.50"
            placeholder="Custom amount"
            value={customAmount}
            onChange={(e) => setCustomAmount(e.target.value)}
          />
          <AmountButton type="submit">Set Amount</AmountButton>
        </form>
      </CustomAmount>

      <StripeCheckout
        amount={amount}
        onSuccess={handleSuccess}
        onError={handleError}
      />

      {status && (
        <Status>
          <strong>Payment Status:</strong>
          <pre>{status}</pre>
        </Status>
      )}
    </Container>
  );
};

export default StripeTest;
